import { convertToJalali } from "../../mini_components/ConvertToJalali";
import CopyButton from "./../../ui/CopyButton";
import { useDeleteApiKey } from "./../../lib/queries/queriesAndMutations";

import { toast } from "react-toastify";
import { useQueryClient } from "@tanstack/react-query";
import AlertButton from "../../shared/AlertButton";
import Loader from "../../shared/Loader";
import icons from "../../lib/icons";

const ApiKeyCard = ({ item }) => {
  const { mutateAsync: deleteApiKey, isPending: isPendingDeletingApiKey } =
    useDeleteApiKey();
  const queryClient = useQueryClient();
  const handleDeleteApiKey = async (api_key) => {
    try {
      const response = await deleteApiKey(api_key);
      if (response.status === 204) {
        toast.success("عملیات موفق");
        queryClient.invalidateQueries({ queryKey: ["getApiKeys"] });
      }
    } catch (error) {
      console.error("Error processing form:", error);
    }
  };

  return (
    <div className="flex flex-col bg-primary-20 rounded-[12px] p-[10px] w-fit min-w-[340px] gap-5  ">
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-2">
          <div className="bg-[#E7E9EC] p-[10px] rounded-lg">
            <img
              src={icons.security}
              alt="security-icon"
              width={16}
              height={16}
            />
          </div>
          <p className="flex-1 font-semibold text-[12px] max-w-[150px] truncate" title={item.title}> {item.title}</p>
        </div>
        <p className="text-[10px]  "> {convertToJalali(item.created_at)}</p>
      </div>

      <p className="text-[16px] mx-auto text-dark  ">
        {item.api_key.slice(0, 5) + "******" + item.api_key.slice(-5)}
      </p>

      <div className=" flex justify-between items-end    ">
        <div className="px-[10px]  text-[12px] md:text-[16px] bg-neutral-20 text-dark   rounded-md ">
          {item.active ? "فعال" : "غیرفعال"}
        </div>
        <div className=" flex gap-1 items-center  h-full     ">
          <CopyButton copyText={item.api_key} />
          {!isPendingDeletingApiKey ? (
            <AlertButton
              onClick={() => handleDeleteApiKey(item.api_key)}
              className="red-btn flex items-center gap-1 mr-auto"
            >
              <p>حذف</p>
              <img
                src={icons.trash}
                alt="edit-icon"
                width={16}
                height={16}
              />{" "}
            </AlertButton>
          ) : (
            <div className="w-6 h-6">
              <Loader />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
export default ApiKeyCard;
